import {useDispatch, useSelector} from 'react-redux'
import {useGetRoomOfferAnalyticsContexts} from 'hooks/useGetRoomOfferAnalyticsContexts'
import {getMeta} from 'modules/meta/selectors'
import {getShowTotalPrices} from 'modules/sapiSearch/selectors'
import {getLandingTrafficSource} from 'modules/search/selectors'
import {getSearchIdFromConditionalSource} from 'modules/searchApi/selectors'
import {v4 as uuidv4} from 'uuid'

import {getQueryStringObject} from '@daedalus/core/src/_web/utils/url'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page,
  Team
} from '@daedalus/core/src/analytics/types/Events'
import {RoomWithoutOffers} from '@daedalus/core/src/room/types/room'

import {getSplitBookingCheckoutLink} from './utils'

export const useSplitBookingRoomOfferInteraction = ({
  bundleId,
  rooms,
  sbCheckoutUrl,
  providerCode,
  providerRateType,
  cug
}: {
  bundleId
  rooms: RoomWithoutOffers[]
  sbCheckoutUrl: string
  providerCode: string
  providerRateType?: string
  cug: string[]
}) => {
  const dispatch = useDispatch()
  // Parsing redirectId straight from native search object because we don't want to de-memoise all selectors based on state query string.
  // Using getQueryStringObject instead of URLSearchParams because native parsing extracts param incorrectly (returns just first symbol).
  const urlRedirectId = getQueryStringObject()?.['redirectId']

  const meta = useSelector(getMeta)
  const showTotalPrices = useSelector(getShowTotalPrices)
  const redirectId =
    typeof urlRedirectId === 'string' ? urlRedirectId : uuidv4()
  const landingTrafficSource = useSelector(getLandingTrafficSource)
  const searchId = useSelector(getSearchIdFromConditionalSource)
  const offerUrl = getSplitBookingCheckoutLink({
    meta,
    redirectId,
    landingTrafficSource,
    providerCode,
    providerRateType,
    cug,
    room: rooms[0],
    sbCheckoutUrl,
    bundleId,
    searchId,
    showTotalPrices
  })

  const analyticsContext = useGetRoomOfferAnalyticsContexts({
    id: bundleId,
    isSplitBooking: true
  })

  const handleClick = () => {
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.RoomOffer,
        action: Action.Clicked,
        team: Team.Select,
        analyticsContext,
        page: Page.Accommodation
      })
    )
    window.location.assign(offerUrl)
  }

  return {handleClick}
}
